export default __webpack_public_path__ + "static/media/redArrow.445d7741.svg";